import { render, staticRenderFns } from "./customProduct.vue?vue&type=template&id=79701c26&scoped=true"
import script from "./customProduct.vue?vue&type=script&lang=js"
export * from "./customProduct.vue?vue&type=script&lang=js"
import style0 from "./customProduct.vue?vue&type=style&index=0&id=79701c26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79701c26",
  null
  
)

export default component.exports